export function isRequired(val) {
    return (!!val && val.toString().trim().length > 0) || "Ce champ est obligatoire";
}

export function validateEmail(email) {
    return (
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
            email
        ) || "Veuillez entrer une adresse email valide"
    );
}
